import { Pane, Heading, Badge, Text } from 'evergreen-ui';
import useWindowSize from '../../../utils/useWindowSize';
import { ShiftClock, ShiftBar } from './ShiftClock';
import { isAbsence } from '../../../utils/turniAbsences';

export default function VistaCompatta({
  mockDays,
  showOnlyUncovered,
  handleDayClick,
  getStatusColor
}) {
  const isMobile = useWindowSize() < 768;
  const giorniSettimana = ['LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB', 'DOM'];

  if (isMobile) {
    return (
      <Pane display="flex" flexDirection="column" gap={12}>
        {mockDays.map((day, dIdx) => {
          if (!day) return null;

          if (showOnlyUncovered && day.status === 'coperto') {
            return (
              <Pane key={`hidden_${day.date}`} background="tint1" border="none" borderRadius={8} padding={12} opacity={0.5} display="flex" justifyContent="space-between" alignItems="center">
                <Pane display="flex" alignItems="baseline" gap={8}>
                  <Heading size={500} color="muted">{day.date}</Heading>
                  <Text size={300} color="muted">{giorniSettimana[dIdx % 7]}</Text>
                </Pane>
                <Text size={300} color="muted" fontWeight="bold">COPERTO</Text>
              </Pane>
            );
          }

          const assentiCount = day.shifts.raw
            ? day.shifts.raw.filter(t => isAbsence(t.shift_type)).length
            : day.shifts.ferie.length;

          return (
            <Pane
              key={day.date}
              background="white"
              border="default"
              borderRadius={8}
              padding={16}
              cursor="pointer"
              hoverElevation={2}
              onClick={() => handleDayClick(day)}
              borderLeft={`6px solid var(--evergreen-colors-${getStatusColor(day.status)}500)`}
            >
              <Pane display="flex" justifyContent="space-between" alignItems="center" marginBottom={8}>
                <Pane display="flex" alignItems="baseline" gap={8}>
                  <Heading size={600}>{day.date}</Heading>
                  <Text size={300} color="muted">{giorniSettimana[dIdx % 7]}</Text>
                </Pane>
                <Badge color={getStatusColor(day.status)} isSolid={day.status === 'scoperto'}>
                  {day.status.toUpperCase()}
                </Badge>
              </Pane>
              <Pane display="flex" flexDirection="column" gap={4}>
                {assentiCount > 0 && <Text size={300} color="danger" fontWeight="bold">{assentiCount} assenti</Text>}
                <Text size={300}>⏱️ In turno: {day.shifts.standard?.length || 0} col.</Text>
              </Pane>
              <ShiftBar rawShifts={day.shifts.raw || []} />
            </Pane>
          );
        })}
      </Pane>
    );
  }

  return (
    <Pane display="grid" gridTemplateColumns="repeat(7, minmax(120px, 1fr))" gap={12}>
      {giorniSettimana.map(g => (
        <Pane key={g} textAlign="center" paddingY={8} background="tint2" borderRadius={4}>
          <Text fontWeight="bold">{g}</Text>
        </Pane>
      ))}
      {mockDays.map((day, dIdx) => {
        if (!day) return <Pane key={`empty_${dIdx}`} background="tint1" border="none" minHeight={120} />;
        if (showOnlyUncovered && day.status === 'coperto') {
          return (
            <Pane key={`hidden_${day.date}`} background="tint1" border="none" borderRadius={8} padding={12} opacity={0.5}>
              <Heading size={500} color="muted">{day.date}</Heading>
              <Text size={300} color="muted">Giornata coperta</Text>
            </Pane>
          );
        }

        const assentiCount = day.shifts.raw
          ? day.shifts.raw.filter(t => isAbsence(t.shift_type)).length
          : day.shifts.ferie.length;

        return (
          <Pane
            key={day.date}
            background="white"
            border="default"
            borderRadius={8}
            padding={12}
            cursor="pointer"
            hoverElevation={2}
            onClick={() => handleDayClick(day)}
            borderTop={`4px solid var(--evergreen-colors-${getStatusColor(day.status)}500)`}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Pane width="100%" display="flex" justifyContent="space-between" alignItems="center" marginBottom={4}>
              <Heading size={500}>{day.date}</Heading>
              <Badge color={getStatusColor(day.status)} isSolid={day.status === 'scoperto'}>
                {day.status.toUpperCase()}
              </Badge>
            </Pane>
            {assentiCount > 0 && <Text size={300} color="danger" width="100%" marginBottom={2}>{assentiCount} assenti</Text>}
            <Text size={300} width="100%" marginBottom={4}>⏱️ {day.shifts.standard?.length || 0} in turno</Text>
            <ShiftClock rawShifts={day.shifts.raw || []} />
          </Pane>
        );
      })}
    </Pane>
  );
}
